module.exports = __webpack_public_path__ + "img/sml_medical_info_icon.5472f11.png";